import { createSlice } from '@reduxjs/toolkit';
import { createChangeUserProfileStatus } from './api';
import { initialState } from './api/interface';

const changeUserProfileStatusSlice = createSlice({
  name: 'changeUserProfileStatus',
  initialState,
  reducers: {
    setLimit: (state, action) => {
      state.limit = action.payload.limit;
      state.status = 'idle';
    },
    setSkip: (state, action) => {
      state.skip = action.payload.skip;
      state.status = 'idle';
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload.currentPage;
    },
    setStatus: (state, action) => {
      state.status = action.payload.status;
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(createChangeUserProfileStatus.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(createChangeUserProfileStatus.fulfilled, (state, action) => {
      state.data.push(action.payload);
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
    });
    builder.addCase(createChangeUserProfileStatus.rejected, (state, _) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
    });

  },
});

export const { setLimit, setSkip, setCurrentPage, setStatus, reset } = changeUserProfileStatusSlice.actions;
export default changeUserProfileStatusSlice.reducer;
